import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p461429515559698432',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
